var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"wrapper"},[_c('h1',{staticClass:"main-title"},[_vm._v("Latest Articles")]),_c('latest',{attrs:{"article-data":_vm.articles[0]}}),_c('list',{attrs:{"article-data":_vm.articles.slice(1)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }